import React, { forwardRef } from 'react'

//style
import { ButtonWrapper } from './index.styles'

const ButtonControl = forwardRef(({ text, className, onClick, isDisable, ...props }, ref) => {
   
    return (
        <ButtonWrapper className={`${className}${isDisable ? " disable" : ""}`} ref={ref} onClick={onClick} isDisable={isDisable} {...props}>
            {text && text}
        </ButtonWrapper>
    )
})

export default ButtonControl
